import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/entregas/${entregaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodas() {
        return axiosJwt
            .get(`${api}/credenciados/uabs/entregas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/entregas/anexos/${entregaAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarValorHora(entregaValorHoraAtualizadoDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/entregas/${entregaValorHoraAtualizadoDto.entregaId}/atualizarvalorhora`,
                entregaValorHoraAtualizadoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDataPrevisao(entregaDataPrevisaoAtualizadaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/entregas/${entregaDataPrevisaoAtualizadaDto.entregaId}/atualizardataprevisao`,
                entregaDataPrevisaoAtualizadaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/entregas/${entregaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/entregas/${entregaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
